import {User} from '@blesk-frontend/api';
import {getUserAvatar} from '@blesk-frontend/auth';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
  Profile,
} from '@blesk-frontend/ui';
import {useNavigate} from '@tanstack/react-router';
import {ChevronDown} from 'lucide-react';
import {useMemo} from 'react';

interface AppSidebarUserProps {
  user: User;
  onClickLogout: () => void;
}

export const AppSidebarUser = ({user, onClickLogout}: AppSidebarUserProps) => {
  const navigate = useNavigate();
  const avatar = useMemo(() => getUserAvatar(user), [user]);

  const isOwner = useMemo(() => {
    return user?.teams.at(0)?.role === 'owner';
  }, [user]);

  const isAllowEditPlans = isOwner && !import.meta.env.VITE_ON_PREMISE_CLIENT_ID;

  return (
    <DropdownMenu modal={false}>
      <DropdownMenuTrigger asChild className="group">
        <div className="flex w-full cursor-pointer items-center gap-2 rounded-md border bg-bg-primary px-2 py-1.5 text-text-secondary">
          {avatar ? (
            <img src={avatar} className="block size-6 rounded-full p-0.5" alt="" />
          ) : (
            <Profile className="size-6 shrink-0" />
          )}
          <div className="truncate">{user.fullName}</div>
          <ChevronDown className="ml-auto size-4 shrink-0 transition-transform group-data-[state=open]:rotate-180" />
        </div>
      </DropdownMenuTrigger>
      <DropdownMenuContent sideOffset={8} className="w-52 text-text-secondary">
        <DropdownMenuItem onClick={() => navigate({to: '/settings'})}>
          <span>Настройки</span>
        </DropdownMenuItem>
        {isAllowEditPlans && (
          <DropdownMenuItem onClick={() => navigate({to: '/plans'})}>
            <span>Тарифы и оплата</span>
          </DropdownMenuItem>
        )}
        <DropdownMenuItem onClick={() => navigate({to: '/team'})}>Команда</DropdownMenuItem>
        <DropdownMenuSeparator />
        <DropdownMenuItem
          className="text-error-primary focus:bg-error-subtle"
          onClick={onClickLogout}
        >
          <span>Выйти</span>
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
